// Gesendete E-Mails (Agent 7A, R-15): je Vorlage gesendet, beantwortet, Antwortquote. Öffnungen und Klicks verfolgt das CRM nicht
// (steht im Hinweis). Versand aus dem CRM gibt es erst seit Runde 6, ältere Zahlen stammen aus Close.
import { berichteApi } from "../api/berichte";
import { Laden } from "../components/Bausteine";
import { BerichtSeite } from "./BerichtSeite";
import { useGeladen } from "./daten";
import { ganzText, zahlText } from "./format";
import { useBerichtSteuerung } from "./steuerung";
import { useBerichtFilter } from "./zustand";

const KEIN_ZUSATZ = {};

export function Gesendet() {
  const filter = useBerichtFilter("diese_woche");
  const steuerung = useBerichtSteuerung({ art: "gesendet", filter, zusatz: KEIN_ZUSATZ, onAnwenden: () => undefined });
  const { eingabe, eingabeSchluessel } = filter;
  const abfrage = useGeladen(() => berichteApi.gesendet({ ...eingabe, vergleich: undefined }), eingabeSchluessel, steuerung.geladen);
  const a = abfrage.daten;
  const quote = (q: number | null | undefined) => (q === null || q === undefined ? "–" : `${zahlText(q)} %`);
  return (
    <BerichtSeite
      art="gesendet"
      filter={filter}
      steuerung={steuerung}
      ohneVergleich
      fehler={abfrage.fehler}
      onNochmal={abfrage.neuLaden}
      csv={[{ titel: "Tabelle als CSV laden", art: "gesendet", parameter: { ...eingabe, vergleich: undefined } }]}
    >
      {!a ? (
        <Laden />
      ) : (
        <div aria-busy={abfrage.laedt}>
          <div className="kachelraster kachelraster--karten">
            <div className="kachel"><div className="kachel__zahl">{ganzText(a.summe?.gesendet)}</div><div className="kachel__titel kachel__titel--fest">Gesendet</div><div className="kachel__unter">E-MAILS</div></div>
            <div className="kachel"><div className="kachel__zahl">{ganzText(a.summe?.beantwortet)}</div><div className="kachel__titel kachel__titel--fest">Beantwortet</div><div className="kachel__unter">MIT ANTWORT</div></div>
            <div className="kachel"><div className="kachel__zahl">{quote(a.summe?.antwortquote)}</div><div className="kachel__titel kachel__titel--fest">Antwortquote</div><div className="kachel__unter">BEANTWORTET VON GESENDET</div></div>
          </div>
          <div className="tabelle-rahmen bericht-tabelle">
            <table className="tabelle">
              <thead>
                <tr>
                  <th className="bericht-tabelle__nutzer">E-Mail-Vorlage</th>
                  <th className="bericht-tabelle__zahl">Gesendet</th>
                  <th className="bericht-tabelle__zahl">Beantwortet</th>
                  <th className="bericht-tabelle__zahl">Antwortquote</th>
                </tr>
              </thead>
              <tbody>
                {a.data.length === 0 ? (
                  <tr><td colSpan={4} className="leise">Keine gesendeten E-Mails im Zeitraum.</td></tr>
                ) : (
                  a.data.map((z) => (
                    <tr key={z.vorlage_id ?? "ohne"}>
                      <td className="bericht-tabelle__nutzer">{z.name}</td>
                      <td className="bericht-tabelle__zahl">{ganzText(z.gesendet)}</td>
                      <td className="bericht-tabelle__zahl">{ganzText(z.beantwortet)}</td>
                      <td className="bericht-tabelle__zahl">{quote(z.antwortquote)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {a.hinweis ? <p className="leise bericht-hinweis">{a.hinweis}</p> : null}
        </div>
      )}
    </BerichtSeite>
  );
}
